import "./price-card.scss";
import Button from "@/components/common/buttons/Button";
import pixado from "@/assets/pixado.png";
import fire from "@/assets/fire.png";
import autumnLeaf from "/icons/autumn-leaf.webp";
import { PriceList } from "./PriceList";
import { useNavigate } from "react-router-dom";

const PriceCard = ({
  id,
  title,
  text,
  price,
  links,
  pack,
  button,
  section,
  hot,
  offer,
  webOffer, // NEW: Add webOffer prop
  autumnOffer, // NEW: Add autumnOffer prop
  individualPrice, // NEW: Add individualPrice prop for pack cards
  whatsappMessage, // NEW: Add whatsappMessage prop for black days
}: PriceList & { section: string }) => {
  const navigate = useNavigate();

  // Debug: Check if props are received correctly
  // console.log('PriceCard props:', { id, title, hot, offer, webOffer, text });

  // If hot, offer, webOffer, or autumnOffer, force "Detalii" button
  const buttonText =
    hot || offer || webOffer || autumnOffer
      ? "Detalii"
      : button
        ? button
        : "Cumpara";

  const handleClick = () => {
    // If whatsappMessage exists, open WhatsApp link
    if (whatsappMessage) {
      const phoneNumber = "40745371620";
      const encodedMessage = encodeURIComponent(whatsappMessage);
      const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
      window.open(whatsappUrl, '_blank');
      return;
    }

    // If hot, offer, webOffer, or autumnOffer, always navigate to details
    if ((hot || offer || webOffer || autumnOffer) && id) {
      navigate(`/servicii/${section}/${id}`);
    } else {
      id ? navigate(`/servicii/${section}/${id}`) : navigate("/contact");
    }
  };

  return (
    <>
      {pack && (
        <div className="pack-wrapper">
          <div className="pack">
            <div className="title-3">Alege pachetul </div>
            <div className="title-4">*rezultate garantate</div>
          </div>
        </div>
      )}

      <div className="price-card-container">
        <Button
          onClick={handleClick}
          text={buttonText}
          className={`price-card-button ${
            hot
              ? "hot-button"
              : webOffer
                ? "web-offer-button" // NEW: Add web-offer-button
                : autumnOffer
                  ? "autumn-offer-button" // NEW: Add autumn-offer-button
                  : offer
                    ? "offer-button"
                    : pack
                      ? "pack-button" // 👈 ADD THIS HERE, NOT IN THE CARD DIV
                      : ""
          }`}
        />
        <div className="price-card-wrapper">
          <img
            className={`price-card-icon ${pack ? `` : `price-card-pixado`}`}
            src={
              pack || hot || offer || webOffer
                ? fire
                : autumnOffer
                  ? autumnLeaf
                  : pixado
            } // NEW: Use autumn leaf for autumnOffer
            alt="pixado"
          />
          <div
            className={`price-card ${
              pack
                ? "price-card-pack"
                : hot
                  ? "price-card-hot"
                  : webOffer
                    ? "price-card-web-offer" // NEW: Add price-card-web-offer
                    : autumnOffer
                      ? "price-card-autumn-offer" // NEW: Add price-card-autumn-offer
                      : offer
                        ? "price-card-offer"
                        : pack
                          ? "pack-button" // 👈 ADD THIS
                          : "price-card-normal"
            }`}
          >
            <div className="price-card-text">
              <div className="title-3">{title}</div>

              <div className="body card-text">
                {hot || offer || webOffer || autumnOffer ? ( // NEW: Include autumnOffer in special text logic
                  <>
                    {autumnOffer ? (
                      <>
                        {id === "ecommerce-basic" ? (
                          <>
                            Dacă WooCommerce e o Dacia 1300, ăsta e un MINI
                            Cooper S — compact, dar custom și plin de stil.
                          </>
                        ) : id === "website-prezentare-pro" ? (
                          <>
                            Nu, nu e wordpress. <br />
                            wordpress nu știe să fie PRO.
                            <br />
                            Pixado PRO e… PRO. PUNCT.
                          </>
                        ) : (
                          <>Default autumn text</>
                        )}
                      </>
                    ) : (
                      <>
                        50% DISCOUNT in campania
                        <br />
                        "Vara topește prețurile"!
                      </>
                    )}
                    <br />
                    <span
                      style={{
                        textDecoration: "line-through",
                        opacity: 0.7,
                        display: "block",
                        textAlign: "center",
                        fontSize: "32px",
                        fontWeight: "bold",
                        marginTop: "8px",
                      }}
                    >
                      {id === "ecommerce-basic" ? "€2400" : "€1790"}{" "}
                      {/* Fixed: ccshop basic shows €2400, all others show €1790 */}
                    </span>
                  </>
                ) : pack && individualPrice ? (
                  <>
                    {text}
                    <br />
                    <span
                      style={{
                        textDecoration: "line-through",
                        opacity: 0.7,
                        display: "block",
                        textAlign: "center",
                        fontSize: "32px",
                        fontWeight: "bold",
                        marginTop: "8px",
                      }}
                    >
                      {individualPrice}
                    </span>
                  </>
                ) : (
                  text
                )}
              </div>
            </div>
            <div className="price">{price}</div>
            <div className="price-card-links">
              {links.map((link, index) => (
                <div key={index} className="body link">
                  {link}
                </div>
              ))}
            </div>
            <div className="empty-space" />
          </div>
        </div>
      </div>
    </>
  );
};

export default PriceCard;
